import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useContentTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
